/* istanbul ignore file */
export function isPlatformMac() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-select/es/utils/platformUtil.js
// module id = 2440
// module chunks = 0